import React, { useState } from 'react';
import Modal from '../components/Modal';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import LoadMask from "../Utils/LoadMask/LoadMask";
import NavbarModulo from '../components/NavbarModulo';

import {
    renderDayPickerB,
    AsyncSelectField
} from "../Utils/renderField/renderField";

function InformesForm(props) {
    const {
        modulo,
        loader,
        listarProductos,
        reporteKardex,
        excelKardex,
        excelKardexValorizado,
        reporteKardexValorizado,
        listarBodegas,
        reporteExistencia,
        reporteInventarioFisico,
        excelSalidasDeBodegas,
        reporteSalidasDeBodegas,
        reporteEntradasABodegas,
        datos,
        reporteMovimiento,
        reporteExistenciaReservaOS,
        excelExistencia,
        excelEntradasBodegas,
        listarClientes,
        reporteVentasDetalle,
        excelVentasDetalle
    } = props;

    const [estadoModalKardex, cambiarEstadoModalKardex] = useState(false);
    const [estadoModalKardexValorizado, cambiarEstadoModalKardexValorizado] = useState(false);
    const [estadoModalMovimiento, cambiarEstadoModalMovimiento] = useState(false);
    const [estadoModalInventarioFisico, cambiarEstadoModalInventarioFisico] = useState(false);
    const [estadoModalSalidasBodega, cambiarEstadoModalSalidasBodega] = useState(false);
    const [estadoModalEntradasBodega, cambiarEstadoModalEntradasBodega] = useState(false);
    const [estadoModalExistencia, cambiarEstadoModalExistencia] = useState(false);
    const [estadoModalVentasDetalle, cambiarEstadoModalVentasDetalle] = useState(false);
    const [estadoExistenciaProReserva, cambiarEstadoModalExistenciaProReserva] = useState(false);
    
    let autoFocus = true;
    let titulo = 'Informes'
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    return (
        <div>
            <NavbarModulo
                modulo={modulo}
                titulo={titulo}
            />
        
            <div className="container">
                <br/>
                <h4 className='mt-1' style={{ color: "white" }}>Informes</h4>
                <div className="row">
                    <div className="col-xxl-3">
                        <div className="list-group" id="list-tab" role="tablist">
                            <button class="list-group-item list-group-item-action"
                                id="list-home-list"
                                onClick={() => cambiarEstadoModalKardex(!estadoModalKardex)}
                                data-bs-toggle="list"
                                role="tab"
                                href={`/#/inventario/${id_emp[5]}/informes`}
                                aria-controls="list-home">Kardex
                            </button>
                        </div>
                    </div>
                    <div className="col-xxl-3">
                        <div className="list-group" id="list-tab" role="tablist">
                            <button class="list-group-item list-group-item-action"
                                id="list-home-list"
                                onClick={() => cambiarEstadoModalKardexValorizado(!estadoModalKardexValorizado)}
                                data-bs-toggle="list"
                                role="tab"
                                href={`/#/inventario/${id_emp[5]}/informes`}
                                aria-controls="list-home">Kardex valorizado
                            </button>
                        </div>
                    </div>
                    <div className="col-xxl-3">
                        <div className="list-group" id="list-tab" role="tablist">
                            <a class="list-group-item list-group-item-action"
                                id="list-home-list"
                                onClick={() => cambiarEstadoModalMovimiento(!estadoModalMovimiento)}
                                data-bs-toggle="list"
                                role="tab"
                                href={`/#/inventario/${id_emp[5]}/informes`}
                                aria-controls="list-home">Movimiento de productos</a>
                        </div>
                    </div>
                    <div className="col-xxl-3">
                        <div className="list-group" id="list-tab" role="tablist">
                            <a class="list-group-item list-group-item-action"
                                id="list-home-list"
                                onClick={() => cambiarEstadoModalInventarioFisico(!estadoModalInventarioFisico)}
                                data-bs-toggle="list"
                                role="tab"
                                href={`/#/inventario/${id_emp[5]}/informes`}
                                aria-controls="list-home">Inventario fisico</a>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-3 mt-2">
                        <div className="list-group" id="list-tab" role="tablist">
                            <a class="list-group-item list-group-item-action"
                                id="list-home-list"
                                onClick={() => cambiarEstadoModalSalidasBodega(!estadoModalSalidasBodega)}
                                data-bs-toggle="list"
                                role="tab"
                                href={`/#/inventario/${id_emp[5]}/informes`}
                                aria-controls="list-home">Salidas de bodega</a>
                        </div>
                    </div>
                    <div className="col-xxl-3 mt-2">
                        <div className="list-group" id="list-tab" role="tablist">
                            <a class="list-group-item list-group-item-action"
                                id="list-home-list"
                                onClick={() => cambiarEstadoModalEntradasBodega(!estadoModalEntradasBodega)}
                                data-bs-toggle="list"
                                role="tab"
                                href={`/#/inventario/${id_emp[5]}/informes`}
                                aria-controls="list-home">Entradas a bodega</a>
                        </div>
                    </div>
                    <div className="col-xxl-3 mt-2">
                        <div className="list-group" id="list-tab" role="tablist">
                            <a class="list-group-item list-group-item-action"
                                id="list-home-list"
                                onClick={() => cambiarEstadoModalExistencia(!estadoModalExistencia)}
                                data-bs-toggle="list"
                                role="tab"
                                href={`/#/inventario/${id_emp[5]}/informes`}
                                aria-controls="list-home">Existencia de productos</a>
                        </div>
                    </div>
                    <div className="col-xxl-3 mt-2">
                        <div className="list-group" id="list-tab" role="tablist">
                            <button class="list-group-item list-group-item-action"
                                id="list-home-list"
                                onClick={() => cambiarEstadoModalVentasDetalle(!estadoModalVentasDetalle)}
                                data-bs-toggle="list"
                                role="tab"
                                href={`/#/inventario/${id_emp[5]}/informes`}
                                aria-controls="list-home">Ventas por producto
                            </button>
                        </div>
                    </div>
                </div>
                {datos.ordenes_servicio === 'S' &&
                    <div>
                        <br/>
                        <h4 className='mt-1' style={{ color: "white" }}>Ordenes de servicio</h4>
                        <div className="row">
                            <div className="col-xxl-4">
                                <div className="list-group" id="list-tab" role="tablist">
                                    <button class="list-group-item list-group-item-action"
                                        id="list-home-list"
                                        onClick={() => cambiarEstadoModalExistenciaProReserva(!estadoExistenciaProReserva)}
                                        data-bs-toggle="list"
                                        role="tab"
                                        href={`/#/inventario/${id_emp[5]}/informes`}
                                        aria-controls="list-home">Existen de productos en reserva
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <Modal
                    estado={estadoModalKardex} //Kardex
                    cambiarEstado={cambiarEstadoModalKardex}
                    titulo="Kardex"
                    botonCerrar="true"
                    >
                        <Contenido>
                            <div className='row'>
                                <div className='col-6 mb-2'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="fechaInicial_kardex"
                                        component={renderDayPickerB}
                                        msj="Fecha del"
                                    />
                                </div>
                                <div className='col-6 mb-2'>
                                    <Field
                                        name="fechaFinal_kardex"
                                        component={renderDayPickerB}
                                        msj="Fecha al"
                                    />
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="producto_kardex"
                                    placeholder="Producto..."
                                    className="form-control-find"
                                    component={AsyncSelectField}
                                    loadOptions={listarProductos}
                                    msj="Producto"
                                />
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="bodega_kardex"
                                    placeholder="Bodega..."
                                    className="form-control-find"
                                    loadOptions={listarBodegas}
                                    component={AsyncSelectField}
                                    msj="Bodega"
                                />
                            </div>
                        </Contenido>
                        <LoadMask loading={loader} dark>
                            <Contenido>
                                <div>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={reporteKardex}
                                    >
                                    Generar Reporte
                                    </button>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={excelKardex}
                                    >
                                    Exportar Excel
                                    </button>
                                </div>
                                <button
                                    className='btn mr-2 mb-3 btn btn-secondary'
                                    onClick={() => cambiarEstadoModalKardex(false)}
                                >
                                Cancelar
                                </button>
                            </Contenido>
                        </LoadMask>
                </Modal>
                <Modal
                    estado={estadoModalKardexValorizado} //Kardex valorizado
                    cambiarEstado={cambiarEstadoModalKardexValorizado}
                    titulo="Kardex valorizado"
                    botonCerrar="true"
                    >
                        <Contenido>
                            <div className='row'>
                                <div className='col-6 mb-2'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="fechaInicial"
                                        component={renderDayPickerB}
                                        msj="Fecha del"
                                    />
                                </div>
                                <div className='col-6 mb-2'>
                                    <Field
                                        name="fechaFinal"
                                        component={renderDayPickerB}
                                        msj="Fecha al"
                                    />
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="producto"
                                    placeholder="Producto..."
                                    className="form-control-find"
                                    component={AsyncSelectField}
                                    loadOptions={listarProductos}
                                    msj="Producto"
                                />
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="bodega"
                                    placeholder="Bodega..."
                                    className="form-control-find"
                                    loadOptions={listarBodegas}
                                    component={AsyncSelectField}
                                    msj="Bodega"
                                />
                            </div>
                        </Contenido>
                        <LoadMask loading={loader} dark>
                            <Contenido>
                                <div>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={reporteKardexValorizado}
                                    >
                                    Generar Reporte
                                    </button>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={excelKardexValorizado}
                                    >
                                    Exportar Excel
                                    </button>
                                </div>
                                <button
                                    className='btn mr-2 mb-3 btn btn-secondary'
                                    onClick={() => cambiarEstadoModalKardexValorizado(false)}
                                >
                                Cancelar
                                </button>
                            </Contenido>
                        </LoadMask>
                </Modal>
                <Modal
                    estado={estadoModalMovimiento} //Movimiento de productos
                    cambiarEstado={cambiarEstadoModalMovimiento}
                    titulo="Movimiento de productos"
                    botonCerrar="true"
                    >
                        <Contenido>
                            <div className='row'>
                                <div className='col-6 mb-2'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="fechaInicial_mov"
                                        component={renderDayPickerB}
                                        msj="Fecha del"
                                    />
                                </div>
                                <div className='col-6 mb-2'>
                                    <Field
                                        name="fechaFinal_mov"
                                        component={renderDayPickerB}
                                        msj="Fecha al"
                                    />
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="producto_mov"
                                    placeholder="Producto..."
                                    className="form-control-find"
                                    component={AsyncSelectField}
                                    loadOptions={listarProductos}
                                    msj="Producto"
                                />
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="bodega_mov"
                                    placeholder="Bodega..."
                                    className="form-control-find"
                                    loadOptions={listarBodegas}
                                    component={AsyncSelectField}
                                    msj="Bodega"
                                />
                            </div>
                        </Contenido>
                        <LoadMask loading={loader} dark>
                            <Contenido>
                                <div className='row'>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={reporteMovimiento}
                                    >
                                    Generar Reporte
                                    </button>
                                    <button
                                        className='btn mr-2 mb-3 btn btn-secondary'
                                        onClick={() => cambiarEstadoModalMovimiento(false)}
                                    >
                                    Cancelar
                                    </button>
                                </div>
                            </Contenido>
                        </LoadMask>
                </Modal>  
                <Modal
                    estado={estadoModalInventarioFisico} // Inventario fisico
                    cambiarEstado={cambiarEstadoModalInventarioFisico}
                    titulo="Inventario fisico"
                    botonCerrar="true"
                    >
                        <Contenido>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="bodega_fisico"
                                    placeholder="Bodega..."
                                    className="form-control-find"
                                    component={AsyncSelectField}
                                    loadOptions={listarBodegas}
                                    msj="Bodega"
                                />
                            </div>
                        </Contenido>
                        <LoadMask loading={loader} dark>
                            <Contenido>
                                <div className='row'>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={reporteInventarioFisico}
                                    >
                                    Generar Reporte
                                    </button>
                                    <button
                                        className='btn mr-2 mb-3 btn btn-secondary'
                                        onClick={() => cambiarEstadoModalInventarioFisico(false)}
                                    >
                                    Cancelar
                                    </button>
                                </div>
                            </Contenido>
                        </LoadMask>
                </Modal>  
                <Modal
                    estado={estadoModalSalidasBodega} // Salidas de bodegas
                    cambiarEstado={cambiarEstadoModalSalidasBodega}
                    titulo="Salidas de bodega"
                    botonCerrar="true"
                    >
                        <Contenido>
                            <div className='row'>
                                <div className='col-6 mb-2'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="fechaInicial_sal"
                                        component={renderDayPickerB}
                                        msj="Fecha del"
                                        />
                                </div>
                                <div className='col-6 mb-2'>
                                    <Field
                                        name="fechaFinal_sal"
                                        component={renderDayPickerB}
                                        msj="Fecha al"
                                        />
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="bodega_sal"
                                    placeholder="Bodega..."
                                    className="form-control-find"
                                    component={AsyncSelectField}
                                    loadOptions={listarBodegas}
                                    msj="Bodega"
                                />
                            </div>
                        </Contenido>
                        <LoadMask loading={loader} dark>
                            <Contenido>
                                <div>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={reporteSalidasDeBodegas}
                                    >
                                    Generar Reporte
                                    </button>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={excelSalidasDeBodegas}
                                    >
                                    Exportar Excel
                                    </button>
                                </div>
                                <button
                                    className='btn mr-2 mb-3 btn btn-secondary'
                                    onClick={() => cambiarEstadoModalSalidasBodega(false)}
                                    >
                                    Cancelar
                                </button>
                                
                            </Contenido>
                        </LoadMask>
                </Modal>  
                <Modal
                    estado={estadoModalEntradasBodega} // Entradas a bodega
                    cambiarEstado={cambiarEstadoModalEntradasBodega}
                    titulo="Entradas a bodega"
                    botonCerrar="true"
                    >
                        <Contenido>
                            <div className='row'>
                                <div className='col-6 mb-2'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="fechaInicial_entrada"
                                        component={renderDayPickerB}
                                        msj="Fecha del"
                                        />
                                </div>
                                <div className='col-6 mb-2'>
                                    <Field
                                        name="fechaFinal_entrada"
                                        component={renderDayPickerB}
                                        msj="Fecha al"
                                        />
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="bodega_entrada"
                                    placeholder="Bodega..."
                                    className="form-control-find"
                                    component={AsyncSelectField}
                                    loadOptions={listarBodegas}
                                    msj="Bodega"
                                />
                            </div>
                        </Contenido>
                        <LoadMask loading={loader} dark>
                            <Contenido>
                                <div>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={reporteEntradasABodegas}
                                    >
                                    Generar Reporte
                                    </button>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={excelEntradasBodegas}
                                    >
                                    Exportar Excel
                                    </button>
                                </div>
                                <button
                                    className='btn mr-2 mb-3 btn btn-secondary'
                                    onClick={() => cambiarEstadoModalEntradasBodega(false)}
                                    >
                                    Cancelar
                                </button>
                            </Contenido>
                        </LoadMask>
                </Modal>  
                <Modal
                    estado={estadoExistenciaProReserva} //Existencia
                    cambiarEstado={cambiarEstadoModalExistenciaProReserva}
                    titulo="Existencia productos en reserva"
                    botonCerrar="true"
                    >
                        <Contenido>
                            <div className='row'>
                                <div className='col-6 mb-2'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="fechaInicial_reserva"
                                        component={renderDayPickerB}
                                        msj="Fecha del"
                                    />
                                </div>
                                <div className='col-6 mb-2'>
                                    <Field
                                        name="fechaFinal_reserva"
                                        component={renderDayPickerB}
                                        msj="Fecha al"
                                    />
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="producto_reserva"
                                    placeholder="Producto..."
                                    className="form-control-find"
                                    component={AsyncSelectField}
                                    loadOptions={listarProductos}
                                    msj="Producto"
                                />
                            </div>
                        </Contenido>
                        <LoadMask loading={loader} dark>
                            <Contenido>
                                <div className='row'>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={reporteExistenciaReservaOS}
                                    >
                                    Generar Reporte
                                    </button>
                                    <button
                                        className='btn mr-2 mb-3 btn btn-secondary'
                                        onClick={() => cambiarEstadoModalExistenciaProReserva(false)}
                                    >
                                    Cancelar
                                    </button>
                                </div>
                            </Contenido>
                        </LoadMask>
                </Modal>
                <Modal
                    estado={estadoModalExistencia} //Existencia de productos
                    cambiarEstado={cambiarEstadoModalExistencia}
                    titulo="Existencia de productos"
                    botonCerrar="true"
                    >
                        <Contenido>
                            <div className='col-6 mb-2'>
                                <Field
                                    name="fechaFinal_existencia"
                                    component={renderDayPickerB}
                                    msj="Fecha al"
                                />
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="bodega_existencia"
                                    placeholder="Bodega..."
                                    className="form-control-find"
                                    loadOptions={listarBodegas}
                                    component={AsyncSelectField}
                                    msj="Bodega"
                                />
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="producto"
                                    placeholder="Producto..."
                                    className="form-control-find"
                                    component={AsyncSelectField}
                                    loadOptions={listarProductos}
                                    msj="Producto"
                                />
                            </div>
                        </Contenido>
                        <LoadMask loading={loader} dark>
                            <Contenido>
                                <div>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={reporteExistencia}
                                    >
                                    Generar Reporte
                                    </button>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={excelExistencia}
                                    >
                                    Exportar Excel
                                    </button>
                                </div>
                                <button
                                    className='btn mr-2 mb-3 btn btn-secondary'
                                    onClick={() => cambiarEstadoModalExistencia(false)}
                                >
                                Cancelar
                                </button>
                            </Contenido>
                        </LoadMask>
                </Modal> 
                <Modal
                    estado={estadoModalVentasDetalle} //Ventas detalle
                    cambiarEstado={cambiarEstadoModalVentasDetalle}
                    titulo="Ventas detalle"
                    botonCerrar="true"
                    >
                        <Contenido>
                            <div className='row'>
                                <div className='col-6 mb-2'>
                                    <Field
                                        autoFocus={autoFocus}
                                        name="fechaInicial_ventas"
                                        component={renderDayPickerB}
                                        msj="Fecha del"
                                    />
                                </div>
                                <div className='col-6 mb-2'>
                                    <Field
                                        name="fechaFinal_ventas"
                                        component={renderDayPickerB}
                                        msj="Fecha al"
                                    />
                                </div>
                            </div>
                            <div className='col-12 mb-2'>
                                <Field
                                    name="cliente_ventas"
                                    placeholder="Cliente..."
                                    className="form-control-find"
                                    component={AsyncSelectField}
                                    loadOptions={listarClientes}
                                    msj="Cliente"
                                />
                            </div>
                        </Contenido>
                        <LoadMask loading={loader} dark>
                            <Contenido>
                                <div className='mt-2'>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={reporteVentasDetalle}
                                    >
                                        Generar reporte
                                    </button>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={excelVentasDetalle}
                                    >
                                        Exportar excel
                                    </button>
                                </div>    
                                <div className='row'>
                                    <button
                                        className='btn mr-2 mb-3 btn btn-secondary'
                                        onClick={() => cambiarEstadoModalVentasDetalle(false)}
                                    >
                                    Cancelar
                                    </button>
                                </div>
                            </Contenido>
                        </LoadMask>
                </Modal>  
            </div>
        </div>
    );
}

InformesForm.propTypes = {
    loader: PropTypes.bool,
    modulo: PropTypes.object,
    reporteKardexValorizado: PropTypes.func,
    listarProductos: PropTypes.object,
};

export default reduxForm({
    form: 'FormInformesI',

})(InformesForm);


const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;
